import type { Review } from "@/types";
import StarRating from "@/components/base/StarRating";

export default function ReviewsList({ reviews }: { reviews: Review[] }) {
  if (!reviews.length) {
    return (
      <div className="rounded-2xl border border-dashed border-background-200 bg-background-100 px-6 py-10 text-center">
        <i className="ri-chat-smile-2-line text-3xl text-foreground-500"></i>
        <p className="mt-3 text-sm text-foreground-600">No reviews for this car yet — be the first to rent it.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
      {reviews.map((review) => (
        <figure key={review.id} className="rounded-2xl surface-card p-5">
          <div className="flex items-center justify-between">
            <StarRating rating={review.rating} />
            <span className="inline-flex items-center gap-1 text-xs text-accent-400">
              <i className="ri-checkbox-circle-fill"></i> Verified trip
            </span>
          </div>
          <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
            &ldquo;{review.comment}&rdquo;
          </blockquote>
          <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200/70 pt-4">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500/25 font-heading text-sm font-semibold text-secondary-200">
              {(review.reviewer_name || "G").charAt(0)}
            </span>
            <span>
              <span className="block text-sm font-medium text-foreground-950">{review.reviewer_name || "Gari rider"}</span>
              <span className="block text-xs text-foreground-500">Rented this car</span>
            </span>
          </figcaption>
        </figure>
      ))}
    </div>
  );
}